module.exports = __webpack_public_path__ + "img/short.c402d237.png";